module.exports = __webpack_public_path__ + "static/media/ilu4.0b1fdb18.png";